import React from 'react'
import Dialog from 'material-ui-legacy/Dialog'

import SaveButton from './SaveButton'
import CancelButton from './CancelButton'

/*
Props:
- confirmLabel,
  confirmIcon: label and icon for confirm button
               Defaults: "Do it" and checkmark

- cancelLabel,
  cancelIcon: label and icon for cancel button
              Defaults: "Cancel" and close icon

- confirmCallback: function(), called on confirm
- cancelCallback: function(), called on cancel

- title: Dialog title. Default: "Confirmation required"
- open: Boolean - show dialog if true
- style: CSS override

- children: Dialog contents
*/
const ConfirmationDialog = ({
  confirmCallback,
  confirmLabel,
  confirmIcon,
  cancelCallback,
  cancelLabel,
  cancelIcon,
  title,
  open,
  style,
  children
}) => {
  const confirmActions = [
    <SaveButton
      onTouchTap={confirmCallback}
      label={confirmLabel || 'Do it'}
      icon={confirmIcon}
    />,
    <CancelButton
      onTouchTap={cancelCallback}
      label={cancelLabel || 'Cancel'}
      icon={cancelIcon}
    />
  ]

  return (
    <Dialog
      actions={confirmActions}
      modal={false}
      onRequestClose={cancelCallback}
      open={open}
      style={style}
      title={title || 'Confirmation required'}
    >
      {children}
    </Dialog>
  )
}

export default ConfirmationDialog



// WEBPACK FOOTER //
// ./src/components/UI/ConfirmationDialog.jsx